import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { WhatsappConversationModel } from "@jugl-web/rest-api/integrations/models/WhatsappConversation";
import { InstagramConversationModel } from "@jugl-web/rest-api/integrations/models/InstagramConversation";
import {
  TwilioConversationModel,
  WebChatBotConversationModel,
} from "@jugl-web/rest-api";
import { useClientSupportPageContext } from "../../../providers/ClientSupportPageProvider/useClientSupportPageContext";

export const useSelectedConversation = (
  conversations: Array<
    | WhatsappConversationModel
    | InstagramConversationModel
    | WebChatBotConversationModel
    | TwilioConversationModel
  >
) => {
  const { activeConversation } = useParams<string>();
  const { selectedConversation, selectConversation } =
    useClientSupportPageContext();
  const isInitialized = useRef<boolean>(false);
  useEffect(() => {
    if (isInitialized.current) return;
    if (activeConversation && !selectedConversation) {
      const foundConversation = conversations.find(
        (conversation) => conversation.conv_id === activeConversation
      );
      if (foundConversation) {
        selectConversation(foundConversation);
        isInitialized.current = true;
      }
    }
  }, [
    activeConversation,
    conversations,
    selectConversation,
    selectedConversation,
  ]);
};
